import React from 'react'
import close from '../../assets/images/close.svg'
import featured from "../../assets/images/featured.svg";

const AddNewCustomer = (props) => {
    return (
        <div>
            {props?.isNewUserCreate && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user add-new-customer" ref={props?.refrence}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => props?.setIsNewUserCreate(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Add New Customer</div>
                        <div className="popup-form">
                            <div className="form-group">
                                <label>Image</label>

                                <div className={`imageUploadBox`} onClick={(e) => { props.handleImageUpload(e) }}>
                                    <div id="newpageImageUpload" >
                                        <div className='image-upload-content'>
                                            <img src={featured} alt="FeaturedImage" />
                                            <p >
                                                <span>Upload</span> <span>Media </span>
                                                <br />
                                                JPG, PNG (max. 128MB)
                                            </p>
                                        </div>
                                    </div>
                                    <input type="file" id="feature-img" accept="image/*" hidden />
                                </div>
                                {props?.formData?.image && (
                                    <div className="image-preview">
                                        <img
                                            src={props?.formData?.image?.url || ''}
                                            alt={props?.formData?.image?.name || 'Featured Image'}
                                            className="preview-img"
                                        />
                                    </div>
                                )}

                                {props?.errorMessage?.image && (
                                    <p className="error-message">{props?.errorMessage?.image}</p>
                                )}
                            </div>
                            <div className="form-group" >
                                <label>Name</label>
                                <input
                                    className='form-input'
                                    name='fullName'
                                    value={props?.formData?.fullName}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter Name'
                                />
                                {props?.errorMessage?.fullName && <p className='error-message'>{props?.errorMessage?.fullName}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Email</label>
                                <input
                                    className='form-input'
                                    name='email'
                                    value={props?.formData?.email}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter Email'
                                />
                                {props?.errorMessage?.email && <p className='error-message'>{props?.errorMessage?.email}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Password</label>
                                <input
                                    className='form-input'
                                    name='password'
                                    value={props?.formData?.password}
                                    onChange={props?.handleChange}
                                    type='password'
                                    autoComplete='new-password'
                                    placeholder='Enter Password'
                                />
                                {props?.errorMessage?.password && <p className='error-message'>{props?.errorMessage?.password}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Mobile Number</label>
                                <input
                                    className='form-input'
                                    name='mobileNumber'
                                    value={props?.formData?.mobileNumber}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter Mobile Number'
                                />
                                {props?.errorMessage?.mobileNumber && <p className='error-message'>{props?.errorMessage?.mobileNumber}</p>}
                            </div>
                            <div className="form-group" >
                                <label>Location (Optional)</label>
                                <input
                                    className='form-input'
                                    name='location'
                                    value={props?.formData?.location}
                                    onChange={props?.handleChange}
                                    type='text'
                                    placeholder='Enter Location'
                                />
                                {props?.errorMessage?.location && <p className='error-message'>{props?.errorMessage?.location}</p>}
                            </div>
                            {props?.error !== "" && props?.error && <p className='error-message'>{props?.error}</p>}
                            <div className="popup-actions">
                                <button className="cancel-btn" onClick={() => props?.setIsNewUserCreate(false)}>Cancel</button>
                                <button className="save-btn" onClick={props?.handleSubmit}>
                                    {props?.isLoading ?
                                        <div className={`ringLoader loaderContinue`}></div>
                                        :
                                        'Save'
                                    }
                                </button>
                            </div>

                        </div>
                    </div>
                </>
            )}
        </div>
    )
}

export default AddNewCustomer
